// 远端存储的key
export const USER_STORAGE = {
  LOCALE: 'user.setting.locale'
}
